export default __webpack_public_path__ + "static/media/loveseat-1-seat-1-back.b7ec5038.webp";